// extracted by mini-css-extract-plugin
module.exports = {"CategoryCards":"CategoryCards_CategoryCards__2_pun"};